import { PlayerStats as PlayerStatsType } from '../../../types';

export interface Badge {
  type: string;
  text: string;
  style: React.CSSProperties;
}

export const getPositionColor = (position: string) => {
  switch (position) {
    case 'Arquero':
      return '#FFD600';
    case 'Defensor':
      return '#2196F3';
    case 'Mediocampista':
      return '#4CAF50';
    case 'Delantero':
      return '#FF5722';
    default:
      return '#9E9E9E';
  }
};

export const getPositionEmoji = (position: string) => {
  switch (position) {
    case 'Arquero':
      return '🥅';
    case 'Defensor':
      return '🛡️';
    case 'Mediocampista':
      return '⚽';
    case 'Delantero':
      return '🚀';
    default:
      return '👤';
  }
};

export const createBadges = (
  showCreatorBadge: boolean,
  isMVP: boolean,
  isTopScorer: boolean,
  isTopAssister: boolean,
  isTopSaver: boolean,
  safeStats: PlayerStatsType
): Badge[] => {
  const badges: Badge[] = [];
  
  if (showCreatorBadge) {
    badges.push({
      type: 'creator',
      text: 'Organizador',
      style: {
        background: 'linear-gradient(90deg, #FF9800 0%, #FFCC80 100%)',
        color: '#181A1B',
        border: '1.5px solid #FF9800',
        boxShadow: '0 1px 4px #FF980033'
      }
    });
  }
  
  if (isMVP) {
    badges.push({
      type: 'mvp',
      text: `MVP ${safeStats.votePercentage > 0 ? `(${safeStats.votePercentage}%)` : ''}`,
      style: {
        background: 'linear-gradient(90deg, #FFD600 0%, #FFF9C4 100%)',
        color: '#181A1B',
        border: '1.5px solid #FFD600',
        boxShadow: '0 1px 4px #FFD60033'
      }
    });
  }
  
  if (isTopScorer) {
    badges.push({
      type: 'scorer',
      text: 'Goleador',
      style: {
        background: 'linear-gradient(90deg, #00E676 0%, #B2FF59 100%)',
        color: '#181A1B',
        border: '1.5px solid #00E676',
        boxShadow: '0 1px 4px #00E67633'
      }
    });
  }
  
  if (isTopAssister) {
    badges.push({
      type: 'assister',
      text: 'Asistidor',
      style: {
        background: 'linear-gradient(90deg, #7C4DFF 0%, #B388FF 100%)',
        color: '#FFFFFF',
        border: '1.5px solid #7C4DFF',
        boxShadow: '0 1px 4px #7C4DFF33'
      }
    });
  }
  
  if (isTopSaver) {
    badges.push({
      type: 'saver',
      text: 'Guante de Oro',
      style: {
        background: 'linear-gradient(90deg, #00B8D9 0%, #B2EBF2 100%)',
        color: '#181A1B',
        border: '1.5px solid #00B8D9',
        boxShadow: '0 1px 4px #00B8D933'
      }
    });
  }

  return badges;
};

export const getCardStyle = (
  showCreatorBadge: boolean,
  isMVP: boolean,
  isTopScorer: boolean,
  isTopAssister: boolean,
  isTopSaver: boolean
): React.CSSProperties => {
  if (showCreatorBadge) {
    return {
      background: 'linear-gradient(90deg, rgba(255, 152, 0, 0.15) 0%, rgba(255, 204, 128, 0.15) 100%)',
      border: '2.5px solid #FF9800',
      boxShadow: '0 0 16px 2px rgba(255, 152, 0, 0.3)'
    };
  } else if (isMVP) {
    return {
      background: 'linear-gradient(90deg, rgba(255, 214, 0, 0.15) 0%, rgba(255, 249, 196, 0.15) 100%)',
      border: '2.5px solid #FFD600',
      boxShadow: '0 0 16px 2px rgba(255, 214, 0, 0.3)'
    };
  } else if (isTopScorer) {
    return {
      background: 'linear-gradient(90deg, rgba(0, 230, 118, 0.15) 0%, rgba(178, 255, 89, 0.15) 100%)',
      border: '2.5px solid #00E676',
      boxShadow: '0 0 16px 2px rgba(0, 230, 118, 0.3)'
    };
  } else if (isTopAssister) {
    return {
      background: 'linear-gradient(90deg, rgba(124, 77, 255, 0.15) 0%, rgba(179, 157, 255, 0.15) 100%)',
      border: '2.5px solid #7C4DFF',
      boxShadow: '0 0 16px 2px rgba(124, 77, 255, 0.3)'
    };
  } else if (isTopSaver) {
    return {
      background: 'linear-gradient(90deg, rgba(0, 184, 217, 0.15) 0%, rgba(178, 235, 242, 0.15) 100%)',
      border: '2.5px solid #00B8D9',
      boxShadow: '0 0 16px 2px rgba(0, 184, 217, 0.3)'
    };
  }
  
  return {};
};
